import {booleanAttribute, Component, inject, Input, numberAttribute, OnInit, ViewChild} from '@angular/core';
import {Router} from '@angular/router';

import {BarreNavigationItemComponent} from './barre-navigation-item.component';
import {BarreNavigationVersionComponent} from './barre-navigation-version.component';
import {ValBarreNavigationItem} from './DonneesBarreNavigation';
import {VAL_MODE_ROUTEUR, ValNavigationService} from '../../../../../val-definitions-communes-lib/src/public-api';

//Composant barre de navigation
@Component (
{
  selector: 'val-barre-navigation',
  imports: 
  [
    BarreNavigationItemComponent,
    BarreNavigationVersionComponent
  ],
  templateUrl: './barre-navigation.component.html',
  styleUrl: './barre-navigation.component.scss'
})
export class BarreNavigationComponent implements OnInit 
{
  //Création
  //  Paramètres
  //    router : Routeur
  constructor (private router: Router) 
  {
    this.navigationItems = [];
    this.largeur = 200;
    this.ouvert = true;
    this.navigationItemEnCours = null;
    this.urlApiManifest = null;
    this.masquerReleaseNotes = false;
  }

  //Items de la barre de navigation
  @Input ()
  public navigationItems: ValBarreNavigationItem[];
  
  //Largeur de la barre de navigation
  @Input ({transform: numberAttribute})
  public largeur!: number;

  //Indique si la barre de navigation est ouverte
  @Input ({transform: booleanAttribute})
  public ouvert: boolean;

  // URL de l'API manifest (version et notes de version)
  @Input ()
  public urlApiManifest: string | null;

  // Indique si les notes de version doivent être masquées
  @Input ({transform: booleanAttribute})
  public masquerReleaseNotes: boolean;

  @ViewChild ("version")
  public versionComponent!: BarreNavigationVersionComponent;

  //Indique si chaque item a sa propre URL, affichée dans la barre d’adresse (mode routeur)
  private modeRouteur = inject (VAL_MODE_ROUTEUR);
  private navigationService = inject (ValNavigationService);

  //Item en cours
  public navigationItemEnCours: ValBarreNavigationItem | null;

  //Initialiser  
  public ngOnInit () : void 
  {
    this.MasquerElements (!this.ouvert);
  }

  //Sélectionne un item
  //  Paramètres
  //    indexCommande        : Index de la commande
  //    indexGroupeCommandes : Index du groupe de commandes
  public Selectionner (indexCommande: number, indexGroupeCommandes: number | null) : void 
  {
    let navigationItemGroupe: ValBarreNavigationItem | null;
    let navigationItem: ValBarreNavigationItem;

    if (indexGroupeCommandes !== null)
    {
      navigationItemGroupe = this.navigationItems[indexGroupeCommandes];
      navigationItem = navigationItemGroupe.commandes![indexCommande];
    }
    else
    {
      navigationItemGroupe = null;
      navigationItem = this.navigationItems[indexCommande];
    }

    if (navigationItemGroupe && !navigationItemGroupe.ouvert)
      this.OuvrirFermerGroupe (navigationItemGroupe);

    //Sélection faite par l’application (page par défaut) : remplace l’entrée d’historique,
    //sinon « précédent » ramènerait sur une URL qui resélectionne aussitôt cette page
    this.NaviguerVers (navigationItemGroupe, navigationItem, true);
  }

  //Ouvre / ferme le groupe de commandes
  //  Paramètres
  //    barreNavigationItem : Données de l'item
  public OuvrirFermerGroupe (barreNavigationItem: ValBarreNavigationItem) : void 
  {
    if (!barreNavigationItem.ouvert)
    {
      for (const navigationItem of this.navigationItems)
        navigationItem.ouvert = false;

      barreNavigationItem.ouvert = true;
    }
    else
      barreNavigationItem.ouvert = false;
  }

  //Traite le click sur une commandes
  //  Paramètres
  //    navigationItemGroupe : Données du groupe contenant l’item commande
  //    navigationItem       : Données de l’item commande
  public CommandeClick (navigationItemGroupe: ValBarreNavigationItem | null, navigationItem: ValBarreNavigationItem) : void
  {
    this.NaviguerVers (navigationItemGroupe, navigationItem, false);
  }

  //Sélectionne un item et affiche sa page
  //  Paramètres
  //    navigationItemGroupe : Données du groupe contenant l’item commande
  //    navigationItem       : Données de l’item commande
  //    remplacerUrl         : Indique si l’URL de la page remplace l’entrée d’historique en cours (en mode routeur)
  private NaviguerVers (navigationItemGroupe: ValBarreNavigationItem | null, navigationItem: ValBarreNavigationItem, remplacerUrl: boolean) : void
  {
    this.MarquerSelection (navigationItemGroupe, navigationItem);

    if (navigationItem.navigationCommande)
    {
      this.navigationItemEnCours = navigationItem;
      void this.navigationService.Naviguer (navigationItem.navigationCommande, remplacerUrl);
    }
  }

  //Sélectionne l’item correspondant à la page affichée, sans renaviguer
  //Sert aux navigations faites hors de la barre (lien depuis une page)
  //  Retourne
  //    Indique si un item correspond à la page affichée
  public SelectionnerPageAffichee () : boolean
  {
    for (const navigationItem of this.navigationItems)
    {
      if (navigationItem.commandes)
        for (const commandeItem of navigationItem.commandes)
          if (this.EstPageAffichee (commandeItem))
          {
            if (!navigationItem.ouvert)
              this.OuvrirFermerGroupe (navigationItem);

            this.MarquerSelection (navigationItem, commandeItem);
            this.navigationItemEnCours = commandeItem;
            return true;
          }

      if (this.EstPageAffichee (navigationItem))
      {
        this.MarquerSelection (null, navigationItem);
        this.navigationItemEnCours = navigationItem;
        return true;
      }
    }

    //En mode routeur, une page hors menu (ex : « Mes préférences ») ne laisse ni item sélectionné ni titre
    //de la page précédente
    if (this.modeRouteur)
    {
      this.DeselectionnerTout ();
      this.navigationItemEnCours = null;
    }

    return false;
  }

  //Retire la sélection de tous les items
  private DeselectionnerTout () : void
  {
    for (const navigationCmdItem of this.navigationItems)
    {
      navigationCmdItem.selectionne = false;

      if (navigationCmdItem.commandes)
        for (const commandeItem of navigationCmdItem.commandes)
          commandeItem.selectionne = false;
    }
  }

  //Indique si la commande de navigation d’un item correspond à la page affichée
  //  Paramètres
  //    navigationItem : Données de l’item
  private EstPageAffichee (navigationItem: ValBarreNavigationItem) : boolean
  {
    if (!navigationItem.navigationCommande)
      return false;

    return this.router.isActive (this.router.createUrlTree (navigationItem.navigationCommande),
      {paths: "exact", queryParams: "ignored", fragment: "ignored", matrixParams: "ignored"});
  }

  //Marque un item (et son groupe) comme seul sélectionné
  //  Paramètres
  //    navigationItemGroupe : Données du groupe contenant l’item commande
  //    navigationItem       : Données de l’item commande
  private MarquerSelection (navigationItemGroupe: ValBarreNavigationItem | null, navigationItem: ValBarreNavigationItem) : void
  {
    this.DeselectionnerTout ();

    if (navigationItemGroupe)
      navigationItemGroupe.selectionne = true;

    navigationItem.selectionne = true;
  }

  //Initialise
  public Initialiser () : void 
  {
    this.MasquerElements (!this.ouvert);
  }

  //Ouvre / ferme la barre de navigation
  public OuvrirFermer () : void 
  {
    if (this.ouvert)
      this.MasquerElements (this.ouvert);

    this.ouvert = !this.ouvert;

    if (this.ouvert)
      setTimeout (() => {this.MasquerElements (false);}, 200);
  }

  public MasquerElements(masquer: boolean): void
  {
    this.MasquerGroupes (masquer);
    this.MasquerVersion (masquer);
  }
  
  //Masque les groupes d’items
  //  Paramètres
  //    masquer : Indique si il faut masquer les groupes
  public MasquerGroupes (masquer: boolean) : void 
  {
    for (const navigationItem of this.navigationItems)
      navigationItem.masque = masquer;
  }

  public MasquerVersion (masquer: boolean) : void 
  {
    if (this.versionComponent)
      this.versionComponent.masque = masquer;
  }
}
